<template>
  <div class="round-table position-relative">
    <table class="table table-sm table-info table-striped table-bordered">
      <thead>
        <tr>
          <th width="30%">สถิติผลรางวัล</th>
          <th width="30%">5 งวดล่าสุด</th>
          <th width="40%">รางวัล</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items">
          <td>{{ item.note.marketTitle }}</td>
          <td>{{ item.roundDate.date | dispDateTime("DD-MM-YYYY") }}</td>
          <td>{{ item.results.fourNumber[0] }}</td>
        </tr>
        <tr v-if="!items.length">
          <td colspan="3" class="text-center">ไม่มีข้อมูล</td>
        </tr>
      </tbody>
    </table>

    <loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="false"
      background-color="#EBEDEF"
      :height="30"
      :width="30"
      color="#007bff"
    />
  </div>
</template>
<script>
import ReportService from '@/services/ReportService'
import Swal from 'sweetalert2'
import moment from '@/helpers/moment'

export default {
  name: 'RecentResults',
  props: ['marketId'],
  data() {
    return {
      data: null,
      isLoading: false,
      isFail: false
    }
  },
  computed: {
    items() {
      return this.data || []
    }
  },
  watch: {
    marketId() {
      if(this.marketId) {
        this.getResults()
      }
    }
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.isFail = false
      ReportService.getMarketResults(this.marketId, 5).then((response)=>{
        if(response.success) {
          this.data = response.data
        }else{
          throw new Error(response?.message)
        }
      })
      .catch((e)=>{
        this.isFail = true
      })
      .finally(()=>{
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.round-table {
  background-color: #FFF;
}
table {
  thead {
    tr {
      th {
        font-size: 85%;
        text-align: center;
      }
    }
  }
  tbody {
    background-color: #FFFFFF;

    tr {
      td {
        font-size: 85%;
        text-align: center;
      }
    }
  }
}
</style>
